import axiosClient from '../../../config/axios-client'

const AuthService = {
  login(payload) {
    return axiosClient.post(`/session/login`, payload)
  },
  getCurrentUser() {
    return axiosClient.get(`/session/me`)
  },
  logout(){
    return axiosClient.post(`/session/logout`)
  }
}

export default AuthService
